/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";
import { REPORT_ID } from "../constants";

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport();
  const [business] = useParameter<number>("@business-units");
  const [calendar] = useParameter<number[]>("@calendar");
  const [e_countries] = useParameter<number[]>("@e_countries");
  const [e_commodities] = useParameter<number[]>("@e_commodities");
  const [e_calendar] = useParameter<number[]>("@e_calendar");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      name:  { 9: title },
      parameters: {
        "@business-units": business && String(business),
        "@calendar": calendar && calendar.map(String),
        "@e_countries": e_countries && e_countries.map(String),
        "@e_commodities": e_commodities && e_commodities.map(String),
        "@e_calendar": e_calendar && e_calendar.map(String),
      }
    });
  }, [title, subtitle, exportBuilder, business, calendar, e_countries, e_commodities, e_calendar]);
}


